import { Get, Set } from "../../../../Request";
import { useState } from "react";

export const useCreateContract = () => {
    const [step, setStep] = useState(1);
    const [data, setData] = useState({
        itemname: null,
        itemaddres: null,
        managername: null,
        managermobile: null,
        managerntinalcode: null,
        bankname: null,
        banknumber: null,
        bankshaba: null,
        itemtype: null,
        netprice: null,
        bordprice: null,
        signphoto: null,
    });
    const [modal, setModal] = useState({
        visible: false
    });
    const [loading, setloading] = useState(false);
    const CreateContract = data => {
        setloading(true);
        Get({
            url: "/contract/create",
            data: data,
        }).then(res => {
            if (res) {
                setModal({ visible: true, data: res })
            }
            setloading(false);
        });
    };
    return { step, setStep, setData, data, modal, setModal, CreateContract, loading };
};

export const useShowContract = () => {
    const [loading, setloading] = useState(false);
    const [data, setData] = useState(false);
    const [modal, setModal] = useState({
        visible: false
    })
    const getData = tracking => {
        setloading(true);
        Get({
            url: "/contract/tracking",
            data: { trackingnumber: tracking },
        }).then(res => {
            if (res) {
                setModal({ visible: true, data: res })
            }
            setloading(false);
        });
    };
    return { loading, getData, modal, setModal, data };
};